import { useCallback, useEffect } from 'react';
const useCustomBlur = (isOpen, closeMenu, autocompleteClassName) => {
    const handleDocumentClick = useCallback((event) => {
        const classNames = autocompleteClassName.split(' ').join('.');
        if (isOpen && !event.target?.closest(`.${classNames}`)) {
            closeMenu();
        }
    }, [closeMenu, isOpen, autocompleteClassName]);
    useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, [handleDocumentClick]);
};
export default useCustomBlur;
